/** DreamsPOS retail POS visual tokens */
export const dreamsPos = {
  bg: "#f3f4f6",
  panel: "#ffffff",
  border: "#e8e8e8",
  text: "#212b36",
  textMuted: "#637381",
  orange: "#ff9f43",
  orangeDark: "#fe820e",
  green: "#28c76f",
  greenDark: "#20a85a",
  navy: "#092c4c",
  categoryActive: "#ff9f43",
  categoryColors: [
    "#fff4e5",
    "#e8f4fd",
    "#fce8e8",
    "#e8f8f0",
    "#f3e8ff",
    "#fff0e8",
    "#e8f0ff",
  ],
};

export const categoryIconColor = (index: number) =>
  dreamsPos.categoryColors[index % dreamsPos.categoryColors.length];
